// import { getUtility, Icon } from '@livable/saas-react-components';
import {
// Button,
Grid, Paper,
//  Tooltip
Typography } from '@mui/material';
import React from 'react';
// import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
// import UtilityIcon from './UtilityIcon';
// import EditUtilitiesModal from 'src/pages/ResidentsPage/EditUtilitiesModal';
import { monthNames } from 'src/utils/date';
import useStyles from './styles';

// const utilities = [
//   {
//     label: 'water',
//     state: 'error',
//   },
//   {
//     label: 'trash',
//     state: 'error',
//   },
//   {
//     label: 'electricity-com',
//     state: 'warning',
//   },
//   {
//     label: 'satelite',
//     state: 'warning',
//   },
//   {
//     label: 'landscaping',
//     state: 'success',
//   },
//   {
//     label: 'hot-water',
//   },
//   {
//     label: 'sewer',
//   },
//   {
//     label: 'solar',
//   },
// ];

export default function DistributionSummary(_ref) {
  let _ref$propertyData = _ref.propertyData,
    propertyData = _ref$propertyData === void 0 ? {} : _ref$propertyData;
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const accountsReceivable = propertyData.accountsReceivable,
    distributionForCurrentMonth = propertyData.distributionForCurrentMonth,
    distributionForNextMonth = propertyData.distributionForNextMonth,
    distributionToDate = propertyData.distributionToDate,
    nextMonth = propertyData.nextMonth,
    previousMonth = propertyData.previousMonth;

  // const [utilitiesModalIsOpen, setUtilitiesModalIsOpen] = useState(false);
  // const utilitiesModalOpen = () => {
  //   setUtilitiesModalIsOpen(true);
  // };
  // const utilitiesModalClose = () => setUtilitiesModalIsOpen(false);

  const getValue = value => value === null ? 'N/A' : "$".concat(Number(value).toFixed(2));
  return /*#__PURE__*/React.createElement(Paper, null, /*#__PURE__*/React.createElement("div", {
    className: classes.summaryWrapper
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    className: classes.infoContainer
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6,
    md: true,
    className: classes.info
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, getValue(accountsReceivable)), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    color: "light"
  }, t('residencies_page.accounts_receivable'))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6,
    md: true,
    className: classes.info
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, getValue(distributionForCurrentMonth)), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    color: "light"
  }, t('residencies_page.distribution_for', {
    month: monthNames[previousMonth - 1]
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6,
    md: true,
    className: classes.info
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, getValue(distributionToDate)), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    color: "light"
  }, t('residencies_page.distribution_to_date'))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6,
    md: true,
    className: classes.info
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, getValue(distributionForNextMonth)), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    color: "light"
  }, t('residencies_page.estimated_distribution', {
    month: monthNames[nextMonth - 1]
  }))))));
}